import { api, CLAIM_API_SUB_URLS, V2 } from '@/api';
import { AxiosResponse } from 'axios';
import { Module } from 'vuex';
import {
  ClaimDuplicateResponseModel,
  ClaimsPaymentResponseModel,
  ClaimsResponseModel,
  RootState,
} from '@/@types/member';

interface ClaimState {
  eopDetails: ClaimsPaymentResponseModel;
  claimData: ClaimsResponseModel[];
  duplicateClaim: ClaimDuplicateResponseModel[];
}

const CLAIM_STATE: Module<ClaimState, RootState> = {
  state: {
    eopDetails: {} as ClaimsPaymentResponseModel,
    claimData: [],
    duplicateClaim: [],
  },
  actions: {
    // UC-REST-074 Delete Pending Claim
    deletePendingClaim(context, id): Promise<AxiosResponse> {
      return api.delete(
        `${CLAIM_API_SUB_URLS.claims}/${id}`,
      );
    },
    // UC-REST-075 Delete Pending Online Claim
    deletePendingOnlineClaim(context, id): Promise<AxiosResponse> {
      return api.delete(
        `${CLAIM_API_SUB_URLS.onlineClaims}/${id}`,
      );
    },
    // UC-REST-032 Add claim note
    addTransactionNote(context, options): Promise<AxiosResponse> {
      const ID = options.id;
      const PAYLOAD = { memo: options.note };
      return api
        .post(
          `${CLAIM_API_SUB_URLS.claims}/hsa/${ID}/memos${V2}`,
          PAYLOAD,
        )
        .then((note) => {
          return note.data;
        });
    },
    // UC-REST-030 Get EOP Details
    getEOPDetails(context, transactionId): Promise<AxiosResponse> {
      return api
        .get(
          `${CLAIM_API_SUB_URLS.claims}/hsa/${transactionId}/payments${V2}`,
        )
        .then((response) => {
          context.commit('setEOPDetails', {
            id: transactionId,
            data: response.data,
          });
          return response.data;
        });
    },
    // UC-REST-061 - Get Claim Data
    getClaimData(context): Promise<AxiosResponse> {
      return api
        .get(
          `${CLAIM_API_SUB_URLS.claims}/hsa/vault-matches${V2}`,
        )
        .then((response) => {
          context.commit('setClaimData', response.data);
        });
    },

    // UC-REST-227 - Check SAM and Salesforce for Duplicate Claims
    checkSAMAndSalesforceDuplicateClaim(
      context,
      options,
    ): Promise<AxiosResponse> {
      return api
        .get(
          `${CLAIM_API_SUB_URLS.claims}/sam-sf-duplicates?memberId=${options.memberId}&amount=${
            options.amount
          }&startDate=${options.startDate}`,
        )
        .then((response) => {
          context.commit('setDuplicateClaim', response.data);
          return response.data;
        });
    },
  },
  mutations: {
    setEOPDetails(state: ClaimState, data: any) {
      const TRANSACTION_ID = data.id.toString();
      state.eopDetails[TRANSACTION_ID] = data.data;
    },
    setClaimData(state: ClaimState, data: ClaimsResponseModel[]) {
      state.claimData = data;
    },
    setDuplicateClaim(state: ClaimState, data: ClaimDuplicateResponseModel[]) {
      state.duplicateClaim = data;
    },
  },
  getters: {
    eopDetails: (state) => (transactionId): ClaimsPaymentResponseModel => {
      return state.eopDetails[transactionId];
    },
    claimData(state): ClaimsResponseModel[] {
      return state.claimData;
    },
    duplicateClaim(state): ClaimDuplicateResponseModel[] {
      return state.duplicateClaim;
    },
  },
};

export default CLAIM_STATE;
